'use client';

import { c as _c } from "react/compiler-runtime";
import { CAPABILITY_OPTIONS } from '@sizzlenz/shared';
import { TagMultiSelector } from './TagMultiSelector';
interface CapabilitySelectorProps {
  selectedIds: string[];
  onSelectionChange: (ids: string[]) => void;
  disabled?: boolean;
  mode?: 'dropdown' | 'combobox';
}
export function CapabilitySelector(t0) {
  const $ = _c(5);
  const {
    selectedIds,
    onSelectionChange,
    disabled: t1,
    mode: t2
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const mode = t2 === undefined ? "dropdown" : t2;
  let t3;
  if ($[0] !== disabled || $[1] !== mode || $[2] !== onSelectionChange || $[3] !== selectedIds) {
    t3 = <TagMultiSelector label="Capabilities" placeholder="Select capabilities..." searchPlaceholder="Search capabilities..." options={CAPABILITY_OPTIONS} selectedIds={selectedIds} onSelectionChange={onSelectionChange} disabled={disabled} mode={mode} />;
    $[0] = disabled;
    $[1] = mode;
    $[2] = onSelectionChange;
    $[3] = selectedIds;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}